import FileInputService from '@isceco/widget-library2/basic-elements/FileInput/FileInputService.js';
import BerechtigungUtil from './BerechtigungUtil'

export default class BerechtigteFileInputService extends FileInputService {
  getOptions(form) {
    const options = super.getOptions(form)
    const activeProfile = new BerechtigungUtil().getActiveProfile()
    if (activeProfile) {
      options.headers["X-Profile"] = activeProfile.uuid
    }
    return options
  }
}
